<template>
    <div class="w-100 d-flex flex-column justify-content-between">
        <HeaderBar/>
        <div class="px-1 ">
            <div class="d-flex flex-column  mt-4 ">
                <div class="title d-flex justify-content-center align-items-center mt-2">
                    Cancelar Cuenta
                </div> 
            </div>
            <div>
            <validation-observer ref="GanForm">
                <b-form class="auth-register-form " @submit.prevent="">
                    <b-form-group label="Motivo de cancelación" label-for="productSystem" class=" w-100 mr-1">
                        <b-form-select id="productSystem" v-model="cancelationRequest.option_id" :options="Cancelationsoptions" :value="Cancelationsoptions.value" label="text" />
                    </b-form-group>
                    <b-form-group label="Observaciónes" label-for="batch" class="w-100">
                        <b-form-textarea id="batch" v-model="cancelationRequest.description" placeholder="Ayúdanos a mejorar, déjanos saber ¿Por qué nos estas dejando?"/>
                    </b-form-group>
                  
                    <div class="d-flex justify-content-center pb-5 ">
                        <b-button type="submit" v-on:click="insertCancelation"
                            class="bg-primary dataButton  d-flex align-items-center justify-content-center w-75 ">
                            <div class=""> Cancelar mi cuenta </div>
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
            </div>
        </div>
        <ControlMenu />
    </div>
</template>

<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from 'vue-select'
import axios from 'axios'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormTextarea,BFormSelect, BFormGroup, BFormInput, BForm, BImg, BButton, BFormCheckbox } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        ControlMenu,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        HeaderBar,
        BFormInput,
        BForm,
        required,
        vSelect,
        BImg,
        BButton,
        BFormCheckbox,
        BFormTextarea,
        BFormSelect,
    },
    data() {
        return {
            Cancelationsoptions:[
                {value:1, text:'Tengo otra cuenta'},
                {value:2, text:'El app no fue útil'},
                {value:3, text:'Otro'}
            ],
            cancelationRequest:{
                description: '',
                option_id:null,
                user_id:localStorage.getItem('userID'),
            }
        }
    },
    methods: {
        async fetchCancelationOptions(config){
            fetch(this.$apiUrl+"list/cancelations_options", config)
            .then(response => response.json())
            .then(result => {
                this.Cancelationsoptions = result.cancelations_options.map(item => {return {value:item.id,text:item.description}})
            })
        },

        insertCancelation(){
            this.$refs.GanForm.validate().then(success => {
                if(success){
                    let self= this;
                    const token = localStorage.getItem("accessToken");
                    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                    this.$http.post("add/users_cancelation", this.cancelationRequest,config).then(() => {
                        let cancelation={
                            user_id:localStorage.getItem('userID')
                        }
                        self.$http.post("users/delete_account", cancelation, config)
                        //.then(response => response.json())
                        .then(result => {
                            console.log(result);
                        })
                        .catch(error => {
                            console.log(error)
                        });

                        this.$swal({
                            title: 'Cancelación de cuenta',
                            text: 'Hemos cancelado tu cuenta de manera satisfactoria.',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            self.logout();
                        });
                    }).catch(error => {
                        console.log(error)
                    });
                }
            });
            
        },

        logout(){
            localStorage.removeItem('userID');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('userMeta');
            localStorage.removeItem('userData');
            localStorage.removeItem('currentFarm');
            localStorage.removeItem('currentFarmName');
            localStorage.removeItem('refreshToken');
            this.$router.push('/login');
        }

    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        //this.fetchCancelationOptions(config);
    }
}
</script>
    

<style lang="scss" scoped>
.dataUploadTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    color: #5E5873;
}



@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>